import patrycja from '@/assets/img/patrycja.png';

import { i18n } from '@lingui/core';

export enum WebsiteType {
  HELPFIND = 'helpfind',
  DEEPRY = 'deepdry',
}

export const HELPFIND_PHONE = '538 233 974';
export const HELPFIND_PHONE_HH = '718 898 090';
export const HELPFIND_PHONE_PIT = '616 350 050';
export const HELPFIND_PHONE_TRANSMISSION = '880 198 990';

export const API_URL = new URL(import.meta.env.VITE_API_URL).origin;
export const API_API_URL = new URL(import.meta.env.VITE_API_API_URL).origin;
export const CRM_LINK = new URL(import.meta.env.VITE_CRM_LINK).origin;
export const IS_FRESH_DB = import.meta.env.VITE_FRESH_DB === 'true';

export const ERROR_MESSAGES = {
  UNSUPPORTED_PRODUCT: i18n.t('Nieobsługiwany produkt'),
  API_DOWN: i18n.t('Jest problem z połączeniem się z serwerem.'),
  UNSUPPORTED_STAGE: i18n.t('Nieobsługiwany etap sprawy dla danego produktu'),
} as const;

export const PRODUCT = {
  VEHICLE_DAMAGE: IS_FRESH_DB ? 10 : 38,
  VEHICLE_DAMAGE_TRANSPORT: IS_FRESH_DB ? 10 : 79,
  HOUSE_HOLD: IS_FRESH_DB ? 15 : 47,
  PIT: 999,
  TRANSMISSION: IS_FRESH_DB ? 79 : 102,
} as const;

export const CASE_CARD_PRODUCT = {
  SKD: 68,
  CARTEL: 80,
  DEVELOPERS: 87,
  PARABANKS: 82,
  VEHICLE_DAMAGE: 38,
  VEHICLE_DAMAGE_CASHLESS: 96,
  HOUSE_HOLD: 47,
  HOUSE_HOLD_97: 97,
  RETIREMENT: 88,
  DRYING: 72,
  WIBOR: 94,
  TRANSMISSION_EASEMENT: IS_FRESH_DB ? 79 : 102,
  POLISOLOKATY: 76,
  SALARY_EQUALIZATION: 108,
  DEFAULT: 'NOT_FOUND',
};

export const CASE_CARD_SITE = {
  ZGLOSZENIE_SZKODY_OC: 'zgloszenie-szkodyoc.pl',
} as const;

export const CLAIM_PANEL = -1;

export const RESPONSIVE_QUERY = {
  IS_DESKTOP: '(min-width: 1024px)',
  IS_MD: '(min-width: 768px)',
  IS_XS: '(min-width: 480px)',
};

export const FLOODING = 1;

export const PHONE_VALIDATION_REGEX =
  /^(0048|\(?\+?48\)?){0,1}(6[012356789]{1}\d{7}|1[2-8]{1}\d{7}|2[234569]{1}\d{7}|3[2349]{1}\d{7}|4[1234568]{1}\d{7}|5[0-9]{1}\d{7}|[7-8]{1}[1-9]{1}\d{7}|9[145]{1}\d{7})$/;

export const BUILDING_NUMBER_REGEX =
  /^[1-9]\d*(?: ?(?:[a-zA-Z]|[/-] ?\d+[a-zA-Z]?))?$/;

export const FLAG_SESSION = import.meta.env.VITE_FLAG_SESSION === 'true';
// script for future use, generate from [{label: "label", value: 1}, ...] to {LABEL: 1, ...}
//.map((val) => ({[val.label.toUpperCase().replace(/[^\w\s_łżźćńąśęóŁŻŹĆŃĄŚĘÓ]|[\r\n]/g, "").split(' ').join('_')]: val.value})).reduce((a, v) => ({...a, [Object.keys(v)[0].replace(/ą/g,"a").replace(/ć/g,"c").replace(/ę/g,"e").replace(/ł/g,"l").replace(/ń/g,"n").replace(/ó/g,"o").replace(/ś/g,"s").replace(/(ż|ź)/g,"z").replace(/Ą/g,"A").replace(/Ć/g,"C").replace(/Ę/g,"E").replace(/Ł/g,"L").replace(/Ń/g,"N").replace(/Ó/g,"O").replace(/Ś/g,"S").replace(/(Ż|Ź)/g,"Z")]: v[Object.keys(v)[0]]}), {})
export const ATTACHMENT_TYPES = {
  AKT_MALZENSTWA: 460,
  AKT_POSWIADCZENIA_DZIEDZICZENIA__POSTANOWIENIE_O_STWIERDZENIU_NABYCIA_SPADKU: 373,
  AKT_URODZENIA: 200,
  AKT_ZGONU: 24,
  AKTA_SPRAWY: 46,
  AKTA_SZKODOWE: 180,
  AKTUALNY_HARMONOGRAM_SPLAT_KREDYTU: 376,
  ANALIZA_KOSZTORYSU: 464,
  ANALIZA_UMOWY_KREDYTOWEJ: 76,
  ANEKS_DO_UMOWY: 178,
  APELACJA: 169,
  ARKUSZ_RUW: 63,
  ARKUSZ_WYCENY_POJAZDU_PO_SZKODZIE_WRAKU: 60,
  ARKUSZ_WYCENY_POJAZDU_PRZED_SZKODA: 35,
  BILET_NA_LOT_ZASTEPCZY: 222,
  CEIDG: 408,
  CERTYFIKAT_PODPISU_DOCUSIGN: 271,
  CERTYFIKAT_PODPISU_ELEKTRONICZNEGO: 398,
  CESJA_BANKLEASING: 68,
  CESJA_LEASINGU: 89,
  CESJA_PARTNERA: 67,
  CESJA_PARTNERA__POZOSTALE: 110,
  CESJA_PARTNERA__UMOWA: 109,
  CESJA_ZWROTNA: 455,
  COFNIECIE_POZWU: 319,
  DANE_SPRAWCY_WYPADKU_I_JEGO_UBEZPIECZYCIELA: 30,
  DECYZJA: 172,
  DECYZJA_MOPSGOPS: 442,
  DECYZJA_O_WYSOKOSCI_EMERYTURY: 362,
  DECYZJA_O_WYSOKOSCI_RENTY: 361,
  DECYZJA_O_ZASILKU_DLA_BEZROBOTNYCH: 426,
  DECYZJA_O_ZASILKU_DLA_OPIEKUNA_620_ZL: 363,
  DECYZJA_SKO: 441,
  DECYZJA_TU__ODPOWIEDZ_ODMOWNA_NA_WEZWANIE: 163,
  DECYZJA_TU__PROPOZYCJA_UGODY: 164,
  DECYZJA_TU_O_ODMOWIE: 210,
  DECYZJA_TU_O_WYPLACIE_ODSZKODOWANIA: 8,
  DECYZJA_TU_PO_REKLAMACJI: 211,
  DLUGOSC_LOTU_PO_ORTODROMIE: 234,
  DOKUMENT_REJESTROWY: 333,
  DOKUMENT_Z_PORTALI_INFORMACYJNYCH: 433,
  DOKUMENTACJA_FOTOGRAFICZNA_POWSTALYCH_SZKOD: 4,
  DOKUMENTACJA_MEDYCZNA: 74,
  DOKUMENTACJE_HISTORII_LECZENIA: 32,
  DOKUMENTACJE_Z_LECZENIA_LUB_TERAPII_PODJETYCH_WSKUTEK_SMIERCI_BLISKIEJ_OSOBY: 29,
  DOKUMENTY_INNE: 429,
  DOKUMENTY_Z_POSTEPOWANIA_CYWILNEGO: 19,
  DOKUMENTY_Z_POSTEPOWANIA_KARNEGO: 20,
  DOKUMENTY_Z_ULC__WNIOSEK: 159,
  DORECZENIE_OSWIADCZENIA: 459,
  DOWOD_OSOBISTY: 131,
  DRUK_POWIADOMIENIA_DLUZNIKA: 37,
  DRUK_POWIADOMIENIA_DLUZNIKA_NA_PODSTAWIE_PELNOMOCNICTWA_PODPISANY_ELEKTRONICZNIE: 94,
  ETYKIETA: 466,
  ETYKIETA_UPS: 117,
  FAKTURA: 289,
  FAKTURA__KOSZT_USLUGI_MEDYCZNEJ: 75,
  FAKTURA__OPLATA_ZA_WNIOSEK: 268,
  FAKTURA__PORTAL_BENEFICJENTA: 308,
  FAKTURA__ZAKUP_LEKOW_ZAOPATRZENIA_MEDYCZNEGO: 205,
  FAKTURA_DLA_KLIENTA: 328,
  FAKTURA_ENERGIA_ELEKTRYCZNA: 329,
  FAKTURA_GAZ: 332,
  FAKTURA_OPLATA_ZA_ROZLICZENIE: 354,
  FAKTURA_PRO_FORMA: 265,
  FAKTURA_VAT: 58,
  FAKTURA_ZA_BILET: 150,
  FAKTURA_ZA_KOSZTORYS: 40,
  FAKTURA_ZA_NAPRAWE: 49,
  FAKTURA_ZA_OPINIE: 241,
  FAKTURY__INNE_NIZ_Z_LECZENIA: 206,
  FORMULARZ_UZUPELNIAJACY: 270,
  FOTOGRAFIE_UPAMIETNIAJACE_CHWILE_SPEDZONE_Z_OSOBA_ZMARLA: 28,
  FV__DOK_FOTO: 338,
  FV__DOK_CO_I_CWU: 336,
  FV__DOK_OCIEPLENIE: 340,
  FV__DOK_PIEC: 335,
  FV__DOK_STOLARKA_DRZWIOWA: 342,
  FV__DOK_STOLARKA_OKIENNA: 341,
  FV__DOK_TERMOMODERNIZACJA: 337,
  FV_DOK_REKUPERACJA: 339,
  HARMONOGRAM: 358,
  HARMONOGRAM_SPLAT: 87,
  HFF_DRUK_POWIADOMIENIA_DLUZNIKA: 395,
  HFF_PELNOMOCNICTWO_DO_REPREZENTACJI: 390,
  HFF_PELNOMOCNICTWO_DO_ZAWIERANIA_UMOW: 392,
  HFF_PELNOMOCNICTWO_PROCESOWE: 389,
  HFF_RCS: 391,
  HFF_RCS_TLUMACZENIE: 399,
  HFF_UMOWA: 393,
  HFF_ZALACZNIK: 394,
  HISTORIA_DANYCH_LOTU_Z_FLIGHTERANET: 127,
  HISTORIA_DANYCH_LOTU_Z_FLIGHTRADAR24COM: 257,
  HISTORIA_DANYCH_LOTU_Z_RADARBOXCOM: 258,
  HISTORIA_POJAZDU: 286,
  HISTORIA_SPLATY: 402,
  INNA_REZERWACJA_DO_WIADOMOSCI: 227,
  INNE: 249,
  INNE__DO_ANALIZY: 357,
  INNE__JAKIE: 21,
  INNE_DOKUMENTY: 307,
  KARTA_POJAZDU: 81,
  KARTA_POKLADOWA: 120,
  KLAUZULA_WYKONALNOSCI: 174,
  KONSOLIDACJA: 409,
  KOPIA_DOKUMENTACJI_Z_KONTROLI_PRZEPROWADZONEJ_PRZEZ_PANSTWOWA_INSPEKCJE_PRACY: 17,
  KOPIA_PROTOKOLU_USTALENIA_OKOLICZNOSCI_I_PRZYCZYN_WYPADKU_PRZY_PRACY: 14,
  KOPIA_WYROKU_LUB_POSTANOWIENIA_JAKIE_ZOSTALY_WYDANE_W_PRZEDMIOCIE_WYPADKU_WRAZ_Z_KOPIA_OPINII_BIEGLEGO_Z_ZAKRESU_BHP: 16,
  KOPIA_ZALACZNIKOW_DO_PROTOKOLU_POWYPADKOWEGO: 15,
  KOPIE_DOWODU_POTWIERDZAJACEGO_TOZSAMOSC_OSOBY_UBIEGAJACEJ_SIE_O_ZADOSCUCZYNIENIE: 25,
  KOPIE_DOWODU_REJESTRACYJNEGO: 10,
  KOPIE_ODWOLANIA_OD_DECYZJI_TOWARZYSTWA_UBEZPIECZEN: 23,
  KORESPONDENCJA_EMAIL: 369,
  KORESPONDENCJA_KLIENTTU: 182,
  KORESPONDENCJA_Z_LINIAMI: 124,
  KOSZTORYS: 9,
  KOSZTORYS_HELPFIND: 240,
  KOSZTORYS_NIEZALEZNEGO_RZECZOZNAWCY: 64,
  KOSZTORYS_ZWERYFIKOWANY_PRZEZ_TU: 165,
  KREDYT_WE_FRANKACH__RAPORT: 57,
  KRS: 108,
  MAIL_OSWIADCZENIE_DO_BANKU: 430,
  METAR_POGODA: 149,
  NAGRANIE_ROZMOWY_Z_KLIENTEM: 82,
  NAGRANIE_ROZMOWY_Z_TU: 434,
  NAKAZ: 106,
  NAKAZ_ZAPLATY: 175,
  NAKLEJKA_BAGAZOWA: 230,
  NOTAM: 287,
  NOTATKA_POLICYJNA: 5,
  OCENA_TECHNICZNA: 95,
  ODMOWA_MOPS: 364,
  ODMOWA_SKO: 365,
  ODMOWE_WYPLATY_ODSZKODOWANIA_KTORE_WYDALO_TOWARZYSTWO_UBEZPIECZEN: 22,
  ODPOWIEDZ_NA_REKLAMACJE: 50,
  ODPOWIEDZ_BANKU: 103,
  ODPOWIEDZ_NA_APELACJE: 454,
  ODPOWIEDZ_NA_POZEW: 152,
  ODPOWIEDZ_NA_REKLAMACJE_UWH: 83,
  ODPOWIEDZ_NA_SPRZECIW: 293,
  ODPOWIEDZ_NA_WEZWANIE: 52,
  ODPOWIEDZ_NA_WEZWANIE_DO_ZAPLATY: 136,
  ODPOWIEDZ_NEGATYWNA_BANKU: 282,
  ODPOWIEDZ_POZYTYWNA_BANKU: 281,
  ODRZUCENIE_POZWU: 243,
  ODSTAPIENIE_OD_MOZLIWOSCI_ODSTAPIENIA_OD_UMOWY: 380,
  ODWOLANIE_LOTU__INFORMACJA: 199,
  ODWOLANIE_SKO: 439,
  OFERTA_AXPO: 388,
  OFERTA_ZAKUPU_Z_AUKCJI_TU: 168,
  OPINIA_BIEGLEGO: 294,
  OPINIA_RZECZOZNAWCY: 43,
  OPINIA_UZUPELNIAJACA: 418,
  OPIS_DOZNANEJ_KRZYWDY_I_CIERPIENIA: 26,
  OPIS_RELACJI_I_KRZYWDY_NAPISANY_PRZEZ_SWIADKOW: 27,
  OPLATY_SADOWE: 187,
  ORGINALNA_WIADOMOSC_EMAIL: 115,
  ORGINALNA_WIADOMOSC_EMAIL_BEZ_TAGOW_HTML: 116,
  ORZECZENIE_LEKARZA_ORZECZNIKA_ZUS_O__USZCZERBKU_NA_ZDROWIU_ORAZ_DECYZJA_O_PRZYZNANIU_JEDNORAZOWEGO_ODSZKODOWANIA: 18,
  ORZECZENIE_O_NIEPELNOSPRAWNOSCI: 360,
  ORZECZENIE_O_NIEPELNOSPRAWNOSCI_OPIEKUNA: 407,
  ORZECZENIEWYROK_DOWOD: 224,
  OSWIADCZENIE__ROLNIK: 463,
  OSWIADCZENIE__CZYNNOSCIOWKA: 438,
  OSWIADCZENIE_DORECZENIA__DO_WNIOSKU: 310,
  OSWIADCZENIE_KLIENTA: 36,
  OSWIADCZENIE_KLIENTA__VAT: 370,
  OSWIADCZENIE_LEKARSKIE: 368,
  OSWIADCZENIE_POSZKODOWANEGO: 72,
  OSWIADCZENIE_SPRAWCY: 1,
  OSWIADCZENIE_SWIADKASWIADKOW: 2,
  OTA_FORM: 192,
  OWU: 256,
  PASZPORT: 130,
  PCC3: 42,
  PELNOMOCNICTWO: 47,
  PELNOMOCNICTWO__WZOR: 314,
  PELNOMOCNICTWO_DLA_KLIENTA: 260,
  PELNOMOCNICTWO_DO_AS: 272,
  PELNOMOCNICTWO_KLIENT_HELPFIND: 78,
  PIR: 320,
  PISMO_DO_BANKU: 449,
  PISMO_DO_MOPS__GOPS: 406,
  PISMO_INFORMACYJNE_TU: 90,
  PISMO_O_ZWROT_ZALICZKI: 400,
  PISMO_OD_KOMORNIKA: 173,
  PISMO_PROCESOWE: 153,
  PISMO_PROCESOWE__UZUPELNIENIE_POZWU: 292,
  PISMO_Z_MOPS__GOPS: 424,
  PISMO_Z_SADU: 107,
  PIT: 295,
  PIT11: 41,
  POCZTA_POLSKA: 450,
  PODPISANA_UMOWA_Z_LWB: 377,
  PODPISANA_UMOWA_Z_REPLAN: 378,
  PODPISANE_PELNOMOCNICTWO_DO_OBSLUGI_PRAWNEJ_Z_FINANSOWANIEM: 379,
  PODSUMOWANIE_SPRAWY_HARVARD_LAWYERS: 453,
  PODZIAL_MAJATKU: 374,
  POLISA_AC: 59,
  POLISA_OC: 132,
  POLKURIER: 451,
  PONAGLENIE: 155,
  POROZUMIENIE_O_ROZWIAZANIU_UMOWY_CESJI: 327,
  POSTANOWIENIE_O_UMORZENIU_DOCHODZENIASLEDZTWA: 226,
  POSTANOWIENIE_PROKURATURY: 203,
  POTWIERDZENIE_DORECZENIA: 457,
  POTWIERDZENIE_PLATNOSCI_PELNOMOCNICTWA_1: 96,
  POTWIERDZENIE_PLATNOSCI_PELNOMOCNICTWA_2: 97,
  POTWIERDZENIE_PLATNOSCI: 198,
  POTWIERDZENIE_PRZELEWU: 298,
  POTWIERDZENIE_PRZELEWU__KOSZTY_PROCESU_STRONY_PRZECIWNEJ: 359,
  POTWIERDZENIE_PRZELEWU__OPLATA_OD_APELACJI: 356,
  POTWIERDZENIE_PRZELEWU__POZOSTALE_KOSZTY_OPINII_BIEGLEGO: 185,
  POTWIERDZENIE_PRZELEWU__UZASADNIENIE_WYROKU: 322,
  POTWIERDZENIE_PRZELEWU__ZALICZKA_NA_BIEGLEGO: 316,
  POTWIERDZENIE_PRZELEWU__ZWROT_DO_PARTNERA: 323,
  POTWIERDZENIE_PRZELEWU_DLA_KLIENTA: 34,
  POTWIERDZENIE_PRZELEWU_HELPFIND__TUSAD: 315,
  POTWIERDZENIE_PRZELEWU_KOREKTY: 177,
  POTWIERDZENIE_PRZELEWU_NA_RZECZ_BANKU: 101,
  POTWIERDZENIE_PRZELEWU_OPLATY_OD_ZAZALENIA: 324,
  POTWIERDZENIE_PRZELEWU_TU__HELPFIND: 162,
  POTWIERDZENIE_PRZELEWU_TUKLIENT: 91,
  POTWIERDZENIE_PRZELEWU_ZA_PELNOMOCNICTWO: 98,
  POTWIERDZENIE_PRZELEWU_ZALICZKI_DOT_KM: 181,
  POTWIERDZENIE_SPLATY: 100,
  POTWIERDZENIE_SPLATY_Z_DATA: 104,
  POTWIERDZENIE_WPLATY_OPLATY_WPISOWEJ_ZA_ROZPRAWE: 85,
  POTWIERDZENIE_WYPLATY_LUB_PRZELEWU_ODSZKODOWANIA: 13,
  POTWIERDZENIE_WYSLANIA_ROSZCZEN__AUTOMAT: 156,
  POTWIERDZENIE_ZWROTU_OD_LINII_LOTNICZEJ: 213,
  POTWIERDZENIE_ZWROTU_SRODKOW_DO_ANALYZERA: 186,
  POWER_OF_ATTORNEY_ADR: 161,
  POWER_OF_ATTORNEY_TICKET_REFUND_ENG: 135,
  POWIADOMIENIE_DLUZNIKA_O_PRZELEWIE_WIERZYTELNOSCI: 73,
  POZEW: 126,
  POZEW__KOMPLET_DO_DRUKU: 125,
  POZEW_DRAFT: 170,
  PRAWO_JAZDY: 232,
  PROPOZYCJA_ZMIANY_POZWU: 242,
  PROTOKOL_ZDARZENIA_WYDANY_PRZEZ_KRUS: 3,
  PROTOKOL_BHP: 204,
  PROTOKOL_ODBIORU_PRAC: 345,
  PROTOKOL_ROZPRAWY: 220,
  PROTOKOL_SZKODY: 69,
  RACHUNEK: 123,
  RACHUNKI_I_FAKTURY_ZA_PONIESIONE_SZKODY_ZWIAZANE_Z_NAPRAWA: 7,
  RACHUNKI_ZA_PONIESIONE_KOSZTY_LECZENIA: 33,
  RACHUNKIFAKTURY: 183,
  RAPORT_AUDAHISTORY: 184,
  RAPORT_BIK: 247,
  RAPORT_BIK__STARY: 276,
  RAPORT_BIK_FIRMOWY: 321,
  RAPORT_SZKODY: 167,
  RAPORT_UFG: 251,
  REGULAMIN_DO_UMOWY_KREDYTU: 372,
  REGULAMIN_USLUGI_CZYSTE_POWIETRZE: 264,
  REKLAMACJA: 138,
  REPLAN__NIEPODPISANA_OBSLUGA_PRAWNA: 384,
  REPLAN__NIEPODPISANE_PRZEJECIE_DLUGU: 382,
  REPLAN__PODPISANA_OBSLUGA_PRAWNA: 385,
  REPLAN__PODPISANE_PRZEJECIE_DLUGU: 383,
  REPLIKA: 296,
  REZERWACJA: 121,
  RODO: 401,
  ROZPORZADZENIE_WS_LOTOW: 171,
  ROZPRAWA: 154,
  SAD_WEZW_DO_UZUP: 244,
  SKAN_UMOWY_KLIENTA: 80,
  SKARGA_WSA: 440,
  SKYHELP__WYGENEROWANA_CESJA: 111,
  SPRZECIW: 239,
  STARY_KOSZTORYS: 114,
  SWIADECTWO_PRACY: 404,
  TABELA_ODSETEK: 432,
  TABELA_WYLICZEN_POWODA: 317,
  TEST_COVID: 237,
  UBEZPIECZENIE: 238,
  UGODA: 158,
  UMOWA__CENA: 445,
  UMOWA_BIK: 250,
  UMOWA_DO_WYSLANIA: 405,
  UMOWA_DOCHODZENIA_ROSZCZEN__KREDYT_WE_FRANKACH: 318,
  UMOWA_DOFINANSOWANIA: 334,
  UMOWA_DZIERZAWY_ZIEMI: 461,
  UMOWA_KREDYTOWA: 79,
  UMOWA_KUPNASPRZEDAZY: 11,
  UMOWA_LEASINGU: 84,
  UMOWA_NA_PODSTAWIE_PELNOMOCNICTWA: 77,
  UMOWA_NA_PODSTAWIE_PELNOMOCNICTWA_PODPISANA_ELEKTRONICZNIE: 92,
  UMOWA_O_PRACE: 462,
  UMOWA_PODPISANA__SWIADCZENIE_PIELEGNACYJNE: 367,
  UMOWA_PODPISANA_ELEKTRONICZNIE: 66,
  UMOWA_PODPISANA_PRZEZ_KLIENTA: 61,
  UMOWA_PODPISANA_Z_PARTNEREM: 102,
  UMOWA_PPW: 231,
  UMOWA_PRZELEWU_WIERZYTELNOSCI__ARCHIWUM: 71,
  UMOWA_PRZELEWU_WIERZYTELNOSCI__KLIENT: 133,
  UMOWA_PRZELEWU_WIERZYTELNOSCI__PARTNER: 134,
  UMOWA_SPRZEDAZY_ENERGIA: 330,
  UMOWA_SPRZEDAZY_GAZ: 331,
  UMOWA_UWH: 51,
  UMOWA_WINDYKACJI_DLA_KLIENTA: 255,
  UMOWA_WINDYKACJI_ROSZCZEN_ENG: 160,
  UMOWA_WINDYKACJI_ROSZCZEN_PL: 122,
  UMOWA_WINDYKACJI_ROSZCZEN_PLENG: 223,
  UMOWA_Z_BIUREM_PODROZY: 290,
  UMOWA_Z_WYKONAWCA: 387,
  UMOWA_ZLECENIE: 444,
  UMOWA_ZWROTNEGO_PRZELEWU_WIERZYTELNOSCI: 446,
  UWAGI_DO_OPINII: 465,
  UWH__ARKUSZ_USTALENIA: 55,
  UWH__ARKUSZ_USTALENIA_TU: 118,
  UWH__DECYZJA_O_WYPLACIE: 54,
  UWH__KOPIA_KARTY_POJAZDU: 56,
  UWH__ODPOWIEDZ_NA_WNIOSEK_DO_TU: 53,
  UWH__ODPOWIEDZ_NEGATYWNA_NA_WNIOSEK_DO_TU: 119,
  UZASADNIENIE_WYROKU: 325,
  VOUCHER: 217,
  WERYFIKACJA_UFG: 112,
  WERYFIKACJA_UFG__SPRAWCA: 113,
  WEZWANIE_DO_WYPLATY_ODSZKOD_ENG: 129,
  WEZWANIE_DO_ZAPLATY: 176,
  WEZWANIE_DO_ZAPLATY_ODSZKODOWANIA_PL: 128,
  WEZWANIE_DO_ZWROTU_ENG: 229,
  WEZWANIE_DO_ZWROTU_PL: 228,
  WIADOMOSC_EMAIL__SMS: 275,
  WLASCIWOSC_SADU: 214,
  WNIOSEK_CZYSTE_POWIETRZE: 261,
  WNIOSEK_O_AKTUALIZACJE: 274,
  WNIOSEK_O_KLAUZULE_WYKONALNOSCI: 166,
  WNIOSEK_O_PLATNOSC: 344,
  WNIOSEK_O_UZASADNIENIE: 312,
  WNIOSEK_O_WSZCZECIE_EGZEKUCJI: 326,
  WNIOSEK_O_WYDANIE_ZGODY_LEASINGU: 447,
  WPLATY: 248,
  WYCOFANIE_ZGODY: 273,
  WYDRUK_CEIDG: 179,
  WYDRUK_Z_KALKULATORA_DOTACJI: 343,
  WYGENEROWANY_DOKUMENT: 448,
  WYPELNIONY_FORMULARZ: 297,
  WYPOWIEDZENIE_PELNOMOCNICTWA: 371,
  WYROK: 151,
  WYROK_ROZWODOWY: 375,
  WYROK_SADOWY: 12,
  WYROK_WSA: 443,
  WYROK_Z_UZASADNIENIEM: 313,
  WZOR: 456,
  WZOR_UMOWY: 366,
  ZALACZNIK_NR_1_PODPISANY_ELEKTRONICZNIE: 86,
  ZALACZNIK_2_DO_PROGRAMU_CZYSTE_POWIETRZE: 266,
  ZALACZNIK_2A_DO_PROGRAMU_CZYSTE_POWIETRZE: 267,
  ZALACZNIK_2B_DO_PROGRAMU_CZYSTE_POWIETRZE: 309,
  ZALACZNIK_NR_1_DO_UMOWY_PRZELEWU_WIERZYTELNOSCI: 70,
  ZALACZNIK_NR_1_NA_PODSTAWIE_PELNOMOCNICTWA_PODPISANY_ELEKTRONICZNIE: 93,
  ZAMKNIECIE_KREDYTU: 88,
  ZASWIADCZENIE_O_BRAKU_ZALEGLOSCI_W_PLATNOSCIACH_WOBEC_BANKU: 403,
  ZASWIADCZENIE_O_DOCHODZIE: 299,
  ZASWIADCZENIE_O_LOCIE_PAZP: 148,
  ZASWIADCZENIE_O_ODWOLANIU_LOTU: 259,
  ZASWIADCZENIE_O_OPOZNIENIU_LOTU: 157,
  ZASWIADCZENIE_UP: 425,
  ZASWIADCZENIE_Z_BANKU_O_KREDYCIE: 381,
  ZAW_O_PRZELEWIE_WIERZYTELNOSCI: 221,
  ZAWIADOMIENIE_O_CESJI: 458,
  ZAWIADOMIENIE_O_WSZCZECIU_DOCHODZENIASLEDZTWA: 225,
  ZBEDNE: 105,
  ZDJECIA_OBRAZEN_CIALA: 207,
  ZDJECIA_PRAC_ADAPTACYJNYCH: 209,
  ZDJECIA_ZNISZCZONYCH_PRZEDMIOTOW: 208,
  ZDJECIE_TABLICY_INFORMACYJNEJ_Z_LOTNISKA: 137,
  ZDJECIE_USZKODZEN: 38,
  ZGLOSZENIE_SZKODY: 31,
  ZGODA_LEASINGU_NA_WYPLATE: 48,
  ZLECENIE_ZWROTU__POTWIERDZENIE: 216,
  ZMIANA_REZERWACJI: 219,
  ZOBOWIAZANIE_DO_UZUPELNIENIA_POZWU: 291,
  ZPO: 423,
  ZWOLNIENIE_Z_TAJEMNICY_BANKOWEJ: 386,
  ZWROT_POZWU: 233,
  CESJA_INNE: 502,
  PELNOMOCNICTWO_INNE: 503,
  UPOWAZNIENIE_INNE: 504,
  ZLECENIE_USLUGI_OSUSZANIA: 479,
};

export const KASKA_CONSULTANT = {
  name: 'Patrycja',
  jobDescription: 'Specjalistka ds. odszkodowań',
  image: patrycja,
  email: 'odszkodowania@helpfind.pl',
};
